// extracted by mini-css-extract-plugin
module.exports = {"phantomFull":"DiaryControls-module--phantom-full--21ZC4","controls":"DiaryControls-module--controls--zhBlj"};